import { render, staticRenderFns } from "./salesSelect.vue?vue&type=template&id=c1676da2&scoped=true&"
import script from "./salesSelect.vue?vue&type=script&lang=js&"
export * from "./salesSelect.vue?vue&type=script&lang=js&"
import style0 from "./salesSelect.vue?vue&type=style&index=0&id=c1676da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1676da2",
  null
  
)

export default component.exports